import { Box, Button, TextField } from "@mui/material";
import { useNotifications } from "@toolpad/core";
import { useEffect, useState } from "react";
import { changeConfigValue } from "../services/adminService";
import { uploadNavodPdf, uploadAktualitaPdf } from "../services/configService";

export default function ConfigModal({
  selectedConfig,
  setModalVisible,
  setShouldReload,
}) {
  const [name, setName] = useState("");
  const [value, setValue] = useState("");
  const [file, setFile] = useState(null);
  const notifications = useNotifications();

  useEffect(() => {
    setName(selectedConfig?.nazev || "");
    setValue(selectedConfig?.hodnota || "");
    setFile(null);
  }, [selectedConfig]);

  const isCreateMode = !selectedConfig?.nazev;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name.trim()) {
      notifications.show("Název klíče je povinný.", {
        severity: "warning",
        autoHideDuration: 5000,
      });
      return;
    }

    let result;

    if (isFileField && file) {
      // nahrávání souboru na server
      if (name === "Příloha aktuality v PDF") {
        result = await uploadAktualitaPdf(file);
      } else {
        result = await uploadNavodPdf(file);
      }
    } else {
      // klasická změna textové hodnoty
      result = await changeConfigValue(name, value);
    }

    if (!result.success) {
      return;
    }

    setModalVisible(false);
    setShouldReload((prev) => !prev);
    notifications.show("Konfigurace byla úspěšně uložena.", {
      severity: "success",
      autoHideDuration: 5000,
    });
  };

  const isDateField =
    name.toLowerCase().includes("datum") || name.toLowerCase().includes("date");

  const isFileField = name.toLowerCase().includes("pdf");

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        padding: "30px 0px",
        minWidth: "300px",
      }}
    >
      <TextField
        label="Název klíče"
        value={name}
        onChange={(e) => setName(e.target.value)}
        fullWidth
        disabled={!isCreateMode}
      />

      {!isFileField ? (
        <TextField
          label={isDateField ? "Datum" : "Hodnota"}
          type={isDateField ? "date" : "text"}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          fullWidth
        />
      ) : (
        <>
          {file && <span>📄 {file.name}</span>}
          <Button variant="contained" component="label" color="primary">
            Vybrat PDF
            <input
              type="file"
              hidden
              accept="application/pdf"
              onChange={(e) => setFile(e.target.files[0])}
            />
          </Button>
        </>
      )}
      <Button
        type="submit"
        variant="contained"
        color="primary"
        onClick={() => console.log("Uložit")}
      >
        Uložit
      </Button>
    </Box>
  );
}
